import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import {
  fetchOnboardingProcessSteps,
  OnboardingProcessStep,
} from "#modules/onboardingV2/infra/fetchOnboardingProcessSteps.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const onboardingProcessStepsQuery = () => ({
  queryKey: queryKeys.onboardingProcessSteps.all,
  queryFn: () => fetchOnboardingProcessSteps(),
  staleTime: STALE_TIME_L,
});

export const getOnboardingProcessStepsQueryData = (
  queryClient: QueryClient,
): OnboardingProcessStep[] | undefined => {
  return queryClient.getQueryData<OnboardingProcessStep[]>(queryKeys.onboardingProcessSteps.all);
};

type OnboardingProcessStepsQueryDataUpdater =
  | OnboardingProcessStep[]
  | undefined
  | ((old: OnboardingProcessStep[] | undefined) => OnboardingProcessStep[] | undefined);

export const setOnboardingProcessStepsQueryData = (
  queryClient: QueryClient,
  updater: OnboardingProcessStepsQueryDataUpdater,
): OnboardingProcessStep[] | undefined => {
  return queryClient.setQueryData<OnboardingProcessStep[]>(
    queryKeys.onboardingProcessSteps.all,
    updater,
  );
};
